import { oneLine } from 'common-tags/es';

const data = {
    type: 'contentpage',
    path: '/measures/income',
    meta: {
        title: 'Adequate income | Child Poverty',
    },
    title: 'Adequate income',
    intro: [
        oneLine`<p><b>235,400</b> or <b>20.8%</b> of tamariki in Aotearoa New Zealand currently live in low-income households. 
            These are households with less than 50% of the median equivalised disposable household income for the 2017/18 
            base financial year after housing costs.</p>`,
        oneLine`<p>By 2028, the Government has committed to reduce the number of tamariki in low-income 
            households to <b>10%</b>.</p>`,
    ],
    image: {
        filename: 'Income.png',
        alt: '',
    },
    content: [
        oneLine`<p>COVID-19 has impacted on household incomes with sharp increases in requests for hardship 
            assistance and rising unemployment.</p>`,
        oneLine`<p>The Government support package raised benefits by $25 a week and doubled the Winter Energy Payment. 
            Wage subsidy and wage relief payments during lockdown will also have made a difference but, like some 
            temporary income support increases, these are unlikely to offset the longer-term economic impacts of the 
            global recession brought on by the pandemic.</p>`,
        oneLine`<p>Treasury has predicted child poverty rates will increase as a result of COVID-19, but this depends 
            on Government decisions.</p>`,
    ],
};

export default data;
